import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Group } from '../../models/group.model';
import {
  SchoolMember,
  SchoolMemberType,
} from '../../models/member.school.model';
import { MembershipStatus } from '../../models/membership.status';
import { Pagination } from '../../models/pagination.model';

export const getMembers = createAction(
  '[School Member] Get Members',
  props<{
    source: string;
    groupId: string;
    getMemberType?: SchoolMemberType[];
    gradeId?: string;
    academicYear?: number;
    status?: MembershipStatus[];
    lastRecord?: Pagination | null;
    limit?: number;
  }>(),
);

export const getMembersDone = createAction('[School Member] Get Members Done');

export const addMembersToStore = createAction(
  '[School Member] Add Members to store',
  props<{ members: SchoolMember[] }>(),
);
export const addMemberToStore = createAction(
  '[School Member] Add Member to store',
  props<{ member: SchoolMember }>(),
);

export const getMember = createAction(
  '[School Member] Get member',
  props<{ groupId: string; memberId: string }>(),
);

export const getStudentsByParentId = createAction(
  '[School Member] Get Students By Parent Id',
  props<{ groupId: string; memberId: string }>(),
);

export const getMembersFailure = createAction(
  '[School Member] Get Members Failed',
  props<{ error: AppExceptionModel }>(),
);

// Update Member Actions
export const update = createAction(
  '[School Member] Update',
  props<{ id: string; currMember: SchoolMember; member: SchoolMember }>(),
);
export const updateFailure = createAction(
  '[School Member] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Member] Update Success',
  props<{ currMember: SchoolMember; member: SchoolMember }>(),
);

// Update Member Status
export const updateStatus = createAction(
  '[School Member] Update Status',
  props<{ id: string; member: SchoolMember }>(),
);
export const updateStatusFailure = createAction(
  '[School Member] Update Status Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateStatusSuccess = createAction(
  '[School Member] Update Status Success',
  props<{ member: SchoolMember }>(),
);

// Link Parent Student
export const linkParent = createAction(
  '[School Member] Link Parent',
  props<{ student: SchoolMember; parent: SchoolMember }>(),
);
export const linkParentFailure = createAction(
  '[School Member] Link Parent Failure',
  props<{ error: AppExceptionModel }>(),
);
export const linkParentSuccess = createAction(
  '[School Member] Link Parent Success',
  props<{ student: SchoolMember; parent: SchoolMember }>(),
);

// Delink Child Student
export const delinkChild = createAction(
  '[School Member] Delink Child',
  props<{ student: SchoolMember; parent: SchoolMember }>(),
);
export const delinkChildFailure = createAction(
  '[School Member] Delink Child Failure',
  props<{ error: AppExceptionModel }>(),
);
export const delinkChildSuccess = createAction(
  '[School Member] Delink Child Success',
  props<{ student: SchoolMember; parent: SchoolMember }>(),
);

// Delete Member Actions
export const deleteAction = createAction(
  '[School Member] Delete',
  props<{ id: string }>(),
);
export const deleteFailure = createAction(
  '[School Member] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Member] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Member] Clear from store',
  props<{ id: string }>(),
);

export const getMemberStats = createAction(
  '[School Member] Get Member Statistics',
  props<{ groupId: string }>(),
);

export const getMemberStatsDone = createAction(
  '[School Member] Get Member Statistics Done',
  props<{ group: Group }>(),
);
export const getMemberStatsFailure = createAction(
  '[School Member] Member Statistics Failure',
  props<{ error: any }>(),
);

export const clearFromStore = createAction(
  '[Member] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clear = createAction('[School Member] Clear Members');
